export default "__VITE_ASSET__FufXZgZu__"